import React, { useState } from 'react';
import Style from './EnergiaSolarQualidade.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function EnergiaSolarQualidade() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="energia-solar-qualidade">
        <ContainerHome24>
          <div className="qualidade-textos">
            <div className="qualidade-titulos">
              <h3 className="qualidade-titulo">Qualidade e segurança</h3>
              <p className="qualidade-subtitulo">
                A energia solar é a solução para quem procura ter uma rotina sustentável e contar
                com vantagens como:
              </p>
            </div>
          </div>
        </ContainerHome24>
        <div className="qualidade-itens">
          <div className="qualidade-item">
            <img src="assets/energia-solar/qualidade/ic_checking_account_open.svg" alt="" />
            <p className="qualidade-item-texto">Baixo custo de manutenção</p>
          </div>
          <div className="qualidade-item">
            <img src="assets/energia-solar/qualidade/ic_cloud.svg" alt="" />
            <p className="qualidade-item-texto">Geração de energia em dias nublados</p>
          </div>
          <div className="qualidade-item">
            <img src="assets/energia-solar/qualidade/ic_clock.svg" alt="" />
            <p className="qualidade-item-texto">Durabilidade de até 25 anos</p>
          </div>
          <div className="qualidade-item">
            <img src="assets/energia-solar/qualidade/ic_calendar_check.svg" alt="" />
            <p className="qualidade-item-texto">Instalação em até 90 dias</p>
          </div>
        </div>
        <ContainerHome24>
          <div className="qualidade-imagens">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 992 && (
                  <>
                    <picture>
                      {/* <source
                        type="image/webp"
                        srcSet="assets/energia-solar/qualidade/img-qualidade-1.webp"
                      /> */}
                      <source
                        type="image/png"
                        srcSet="assets/energia-solar/qualidade/img-qualidade-1.png"
                      />
                      <img src="assets/energia-solar/qualidade/img-qualidade-1.png" alt="" />
                    </picture>
                    <picture>
                      {/* <source
                        type="image/webp"
                        srcSet="assets/energia-solar/qualidade/img-qualidade-2.webp"
                      /> */}
                      <source
                        type="image/png"
                        srcSet="assets/energia-solar/qualidade/img-qualidade-2.png"
                      />
                      <img src="assets/energia-solar/qualidade/img-qualidade-2.png" alt="" />
                    </picture>
                  </>
                )}
                {width > 992 && (
                  <>
                    <picture>
                      {/* <source
                        type="image/webp"
                        srcSet="assets/energia-solar/qualidade/img-qualidade-1-desk.webp"
                      /> */}
                      <source
                        type="image/png"
                        srcSet="assets/energia-solar/qualidade/img-qualidade-1-desk.png"
                      />
                      <img src="assets/energia-solar/qualidade/img-qualidade-1-desk.png" alt="" />
                    </picture>
                    <picture>
                      {/* <source
                        type="image/webp"
                        srcSet="assets/energia-solar/qualidade/img-qualidade-2-desk.webp"
                      /> */}
                      <source
                        type="image/png"
                        srcSet="assets/energia-solar/qualidade/img-qualidade-2-desk.png"
                      />
                      <img src="assets/energia-solar/qualidade/img-qualidade-2-desk.png" alt="" />
                    </picture>
                  </>
                )}
              </>
            )}
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default EnergiaSolarQualidade;
